import React from "react";
import { PageHeader } from "CommonComponent";

const Header = ({ title = "Monthly Appraisals", children }) => {
  return <PageHeader title={title}>{children}</PageHeader>;
};

export default Header;
